import { ReactElement, useEffect } from 'react';
import { OrcamentoForm } from '../components/Orcamento/OrcamentoForm';
import { color } from 'framer-motion';
import { OrcamentoFormProvider } from '../contexts/OrcamentoFormProvider';

export function OrcamentoPage(): ReactElement {
  return (
    <>
      <div className="overflow-hidden">
        <div className="">
          <div className="h-full pt-8 pb-8 mb-8">
            <article className="-mb-20 bg-transparent max-w-[1551px] max-[1599px]:px-6 mx-auto">
              <h1 className="text-[2.5rem] text-center px-6 text-primary-main mb-4">
                Cotação Produtos Odontológicos PME
              </h1>
              <div className="min-[748px] h-full">
                <OrcamentoFormProvider>
                  <OrcamentoForm />
                </OrcamentoFormProvider>
              </div>
            </article>
          </div>
        </div>
      </div>
    </>
  );
}
